import { type FC, type RefObject, useEffect, useRef } from 'react';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import styles from './MapHTMLContainer.css';

type MapHTMLContainerProps = {
  createMapInstance: (ref: RefObject<HTMLDivElement>) => void;
};

export const MapHTMLContainer: FC<MapHTMLContainerProps> = memoWithDisplayName(props => {
  const { createMapInstance } = props;
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    createMapInstance(mapRef);
  }, [createMapInstance]);

  return <div className={styles['map']} data-testid="map.container" ref={mapRef}></div>;
}, 'MapHTMLContainer');
